// extracted by mini-css-extract-plugin
module.exports = {"EstimateTitle":"Page_EstimateTitle__trYon","Container":"Page_Container__nDgbF","EstimateAddForm":"Page_EstimateAddForm__lRqwC","EstimateList":"Page_EstimateList__w_QAj"};